
<div *ngIf="product" id="container" class="d-flex w-100 h-100 overflow-hidden {{exportMode ? 'flex-row' : 'flex-row-reverse'}}">
  <div class="d-flex flex-column  align-self-stretch align-items-stretch w-75 h-100">
    <div *ngIf="showSelector" class="w-100 h-25">
      <div *ngIf="showSelector" class="p-2">
        <templateSelector (templateSelected)="templateSelected($event)">
        </templateSelector>
      </div>

    </div>
    <div class="w-100 {{showSelector ? 'h-75' : 'h-100'}}">

      <dx-scroll-view class="w-100 h-100" reachBottomText="" showScrollbar="always">
        <div class="flex-fill">
          <templateProduct class="h-100"
                           [model]="product"
                           [(selectedElements)]="selectedElements"
                           [exportMode]="exportMode"
                           [showDragHandle]="exportMode"
                           (elementDeleted)="elementDelete($event)"
                           (elementSelected)="elementSelectFunction($event)"
                           (excelElementDropped)="excelElementDrop($event)"
                           (onValueChanged)="addDefaultElement($event)"
                           [(mimeUpdateMode)]="mimeUpdateMode"
                           (onMimeUpdateModeChanged)="mimeUpdateModeChanged($event)"
                           [(featureUpdateMode)]="featureUpdateMode"
                           (onFeatureUpdateModeChanged)="featureUpdateModeChanged($event)"
                           [(priceUpdateMode)]="priceUpdateMode"
                           (onPriceUpdateModeChanged)="priceUpdateModeChanged($event)"
                           [(udxUpdateMode)]="udxUpdateMode"
                           (onUdxUpdateModeChanged)="udxUpdateModeChanged($event)"
                           [(supplierUpdateMode)]="supplierUpdateMode"
                           (onSupplierUpdateModeChanged)="supplierUpdateModeChanged($event)"
                           [(cateogyUpdateMode)]="categoryUpdateMode"
                           (onCategoryUpdateModeChanged)="categoryUpdateModeChanged($event)">
          </templateProduct>
        </div>
      </dx-scroll-view>
    </div>
  </div>



  <div class="d-flex flex-column align-self-stretch align-items-stretch w-25 h-100">
    <div *ngIf="exportMode" class="w-100 h-25">
      <div class="w-100 h-100 d-flex flex-row">
        <div class="w-50 h-100 px-2 py-5">
          <dx-sortable class="d-flex justify-content-center align-items-center dropZone" style="height: 100%;"
                       group="dragDropGroup"
                       dropFeedbackMode="indicate"
                       (onAdd)="onDropAdd($event)">
            <i class="m-auto dx-icon-add bigIcon"></i>
          </dx-sortable>
        </div>

        <div class="w-50 h-100 px-2 py-5">
          <dx-sortable class="d-flex justify-content-center align-items-center dropZone" style="height: 100%;"
                       group="dragDropGroup"
                       dropFeedbackMode="indicate"
                       (onAdd)="onDropRemove($event)">
            <i class="m-auto dx-icon-trash bigIcon"></i>
          </dx-sortable>
        </div>

      </div>

    </div>
    <div class="w-100 {{exportMode ? 'h-75' : 'h-100'}}">

      <dx-scroll-view class="w-100 h-100" reachBottomText="" showScrollbar="always">
        <div class="flex-fill">
          <templateExcel class="h-100"
                         [(excelModel)]="excelModel"
                         [exportMode]="exportMode"
                         [(selectedElements)]="selectedElements"
                         (updateValue)="updateTemplate($event)"
                         (removeTemplate)="clearItem($event)"
                         (reorderModel)="reorderModel($event)"
                         (replaceItem)="replaceItem($event)"
                         (rowSelected)="excelRowSelected($event)">
          </templateExcel>
        </div>
      </dx-scroll-view>

    </div>

  </div>


  <dx-load-panel [visible]="isVisible"
                 [showIndicator]="true"
                 [showPane]="true"
                 [shading]="true">
  </dx-load-panel>


</div>
